import React from "react";
import { MainLayout } from "../../MainLayout";
import { ZambiaSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";
export const Zambia = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/india-air.png",
            sliderimg: [
                { id: 1, img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zambia-dest-1.webp", title: "Victoria Falls" },
                { id: 2, img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zambia-dest-1.webp", title: "Safari" },
            ],
            title: "3N/4D South Luangwa Safari Adventure",
            days: "3N/4D",
            tags: ["Safari", "WildLife", "WaterFall"],
            description:
                "Experience the awe-inspiring Victoria Falls and enjoy game drives in nearby national parks. This package offers a mix of adventure and wildlife viewing.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zambia-dest-1.webp",
            slug: "luangwaSafari",
        },

        {
            title: "5N/6D The Spirit of Zambia",
            days: "5N/6D",
            tags: ["Beach", "Scenery", "Bird Haven"],
            description:
                "Explore one of Africa's premier wildlife destinations, known for its high concentrations of leopards and wild dogs. This package includes game drives and walking safaris.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zambia-dest-1.webp",
            slug: "fallsExpedition",
        },

        {
            title: "6N/7D Heart of Zambia",
            days: "6N/7D",
            tags: ["Big Five", "Scenery", "Safari"],
            description:
                "Enjoy a unique perspective of the Lower Zambezi National Park with a canoeing safari. This package offers close encounters with wildlife and stunning river views.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zambia-dest-1.webp",
            slug: "cultureAdventure",
        },

        {
            title: "2N/3D Royal Zambia Retreat",
            days: "2N/3D",
            tags: ["Sightseeing", "WaterFall", "Lakes"],
            description:
                "This comprehensive package explores multiple national parks, including South Luangwa, Lower Zambezi, and Kafue, offering a diverse and immersive safari experience.",
            img: "/assets/sunset.jpg",
            slug: "victoriaFalls",
        },
    ];

    const topcitydata = [
        {
            id: 1, title: "Lusaka", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Lusaka%20Zambia.webp", desc: [
                <p><strong>Why Visit: </strong>Lusaka is Zambia’s capital and the economic heart of the country, offering a vibrant mix of cultures, markets, and modern attractions. It serves as a hub for exploring Zambia’s natural wonders, wildlife, and cultural heritage.</p>,
                <p><strong>Top Attractions: </strong>Lusaka National Museum, Kalimba Reptile Park,Munda Wanga Environmental Park, The Kabwata Cultural Village </p>,

            ]
        },
        {
            id: 2, title: "Livingstone", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Zambia%20Top%20places/Zambia%20Top%20places/Living%20stone%20Zambia.webp", desc: [
                <p><strong>Why Visit: </strong>Livingstone is the gateway to Victoria Falls, one of the world’s most iconic natural wonders. It’s a place for both adventure and relaxation, with many activities focused on the falls and the Zambezi River.</p>,
                <p><strong>Top Attractions: </strong>Victoria Falls, Mosi-oa-Tunya National Park,Livingstone Museum, Zambezi River</p>,
            ]
        },
        {
            id: 3, title: "Ndola", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/ndola%20Zambia.webp", desc: [
                <p><strong>Why Visit: </strong>As one of Zambia’s major industrial centers, Ndola offers a mix of urban and nature experiences, with nearby mining and wildlife attractions. The Copperbelt region has a rich mining history.</p>,
                <p><strong>Top Attractions: </strong>Lubuto Mall, Kabwe’s Ng'andu Park, Lake Tanganyika</p>,
            ]
        },
        {
            id: 4, title: "Kitwe", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Zambia%20Top%20places/Zambia%20Top%20places/Kitwe.webp", desc: [
                <p><strong>Why Visit: </strong>Kitwe is Zambia’s second-largest city and is located in the Copperbelt province. It's an important commercial and mining city, with plenty of local culture and nearby natural attractions.</p>,
                <p><strong>Top Attractions: </strong>Kitwe Golf Club, Mindola Dam, Kabwe Market </p>,
            ]
        },
        {
            id: 5, title: "Chipata", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Chipata%20Zambia.webp", desc: [
                <p><strong>Why Visit: </strong>Chipata, in the Eastern Province, is the gateway to one of Africa’s premier safari destinations: South Luangwa National Park. The city offers a mix of urban charm and natural wonders.</p>,
                <p><strong>Top Attractions: </strong>South Luangwa National Park, Chipata’s Traditional Markets </p>,

            ]
        },
        {
            id: 6, title: "Mansa", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Mansa%20Zambia.webp", desc: [
                <p><strong>Why Visit: </strong>Mansa offers a more tranquil atmosphere compared to Zambia’s larger cities. It is located near the stunning Lake Tanganyika, offering a peaceful retreat.</p>,
                <p><strong>Top Attractions: </strong>Lake Tanganyika, Mansa’s Local Markets</p>,
            ]
        },
        {
            id: 7, title: "Solwezi", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Solwezi.webp", desc: [
                <p><strong>Why Visit: </strong>Solwezi is a rapidly growing city in the northwest, known for its mining industry and proximity to the stunning Kundelungu National Park.</p>,
                <p><strong>Top Attractions: </strong>Kundelungu National Park, Lumwana Copper Mine</p>,
            ]
        },
        {
            id: 8, title: "Lusaka's Surrounding Nature", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Lusaka%20surrounding%20area.webp", desc: [
                <p><strong>Why Visit: </strong>Beyond Lusaka’s urban experiences, there are natural escapes nearby, perfect for a short retreat from city life.</p>,
                <p><strong>Top Attractions: </strong>Zambia’s National Parks, Chaminuka Game Reserve</p>,
            ]
        }
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom Zambia Itineraries",
            desc: "Structure journeys that connect Victoria Falls, South Luangwa, and Lower Zambezi into well-paced programs, ideal for travelers seeking depth over fast-paced travel."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Walking Safari Experiences",
            desc: "Position Zambia as the home of walking safaris with guided bush walks in South Luangwa National Park, offering close wildlife encounters in a natural setting."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Victoria Falls & Livingstone Stays",
            desc: "Build stays around Livingstone with access to Victoria Falls and nearby activities, serving as both an entry point and a highlight within itineraries."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "River-Based Safari Experiences",
            desc: "Use the Zambezi River for canoe safaris, sunset cruises, and game viewing from the water, offering a relaxed alternative to traditional game drives."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Low-Density Safari Circuits",
            desc: "Focus on parks like Lower Zambezi National Park where fewer vehicles create a more private experience, ideal for clients seeking exclusivity."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Seasonal Experience Planning",
            desc: "Align itineraries with seasonal highlights such as peak wildlife viewing or river activity windows to optimize travel flow and guest satisfaction."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Bush Camps & Lodge Combinations",
            desc: "Combine remote bush camps with comfortable lodges for varied stay experiences, allowing flexibility across different comfort levels and trip durations."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Multi-Destination Extensions",
            desc: "Position Zambia alongside nearby regions like Zimbabwe or Botswana for extended safari circuits, ideal for travelers exploring multiple iconic African landscapes."
        },
    ];
    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/Zambia%20Banner.webp")'}
                text2={"Zambia"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={ZambiaSec1Data} />
              <IndiaSec2 countryCode="ZM" />
            <IndiaSec3 data={topcitydata} name={"Zambia"} />
            <IndiaSec4
                data={data}
                heading={"Crafting Zambia’s Wild Experiences for Your Clients "}
            />
            <Footer />

        </>
    )


};